import { FC } from "react";
import Header from "./components/Header";
import Navigation from "./components/Navigation";

import "../components/styles.scss";

const AppLayout: FC = ({ children }) => {
  return (
    <div className="fixed flex flex-col items-stretch w-full h-screen overflow-hidden">
      <Header />
      <div className="flex flex-grow h-full overflow-auto">
        <div className="container flex mx-auto max-w-7xl">
          <Navigation />
          <main className="flex container bg-wht overflow-x-auto">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
